import { render, staticRenderFns } from "./NewDesign.vue?vue&type=template&id=8f8334e4&"
import script from "./NewDesign.vue?vue&type=script&lang=js&"
export * from "./NewDesign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports